import { TrackByFunction } from '@angular/core'

interface HasId {
  id: number | string | boolean | null | undefined
}

export const trackById: TrackByFunction<HasId> = (idx, { id }) => id
